"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.array(zod_1.z.object({
    blockId: zod_1.z.number(),
    threshold: zod_1.z.number(),
}));
//# sourceMappingURL=create.js.map